<template>
  <div id="app" class="app">
    <div class="app__main">
      <img class="app__logo" src="@/assets/images/VF_logo_linear_grey_RGB.png" alt="Vattenfall logo" @click="logoHandler()">
      <div class="app__content">
        <router-view/>
      </div>
    </div>
    <div class="app__aside" v-if="this.$route.name == 'Start'">
      <Faq />
    </div>
    <div class="app__footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Faq from '@/templates/components/Faq'
import Footer from '@/templates/components/Footer'

export default {
  name: 'App',
  components: {
    Faq,
    Footer
  },
  methods: {
    logoHandler: function () {
      this.$router.push({ name: 'Start' })
    }
  },
  computed: {
    completed: function () {
      return window.completed
    }
  },
  created: function () {
    console.log('APP created!')
    this.$store.commit('progress/completed', this.completed)
    console.log('APP completed', this.$store.state.progress.completed)
  }
}
</script>

<style lang="scss">
  @import 'assets/styles/app';
</style>



// WEBPACK FOOTER //
// src/App.vue